import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { Tournament } from 'Src/models/tournament';
import { superAdminGet } from './api';

export interface SuperAdminTournamentsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminTournamentsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'startTime DESC'
};

function buildFilter(filter: SuperAdminTournamentsFilter = DEFAULT_FILTER): SuperAdminTournamentsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolTournaments(
  schoolId: string,
  filter: SuperAdminTournamentsFilter = DEFAULT_FILTER
): Promise<Tournament[]> {
  return superAdminGet<Tournament[]>(`/schools/${schoolId}/tournaments`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolTournaments(schoolId: string, where?: any): Promise<Tournament[]> {
  return superAdminGet<Tournament[]>(`/schools/${schoolId}/tournaments`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolTournamentsCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/tournaments/count`, config);
}

export function getSuperAdminSchoolTournament(schoolId: string, tournamentId: string): Promise<Tournament> {
  return superAdminGet<Tournament>(`/schools/${schoolId}/tournaments/${tournamentId}`);
}
